<script>
    export default {
        bind(el, binding, vnode) {
            for (let key in binding.value) {
                el.dataset[key] = binding.value[key];
            }

            window.eventHub.$on('data-filter', (filters) => {
                let hide = false;

                for (let key in filters) {
                    if (binding.value[key] !== filters[key]) {
                        hide = true;
                        break;
                    }
                }

                if (hide) {
                    el.dataset['hide'] = 'hide';
                    el.style.display = "none";
                } else {
                    delete el.dataset['hide'];
                    el.style.display = "block";
                }

                $(".group-list .group-item:visible").matchHeight({
                    byRow: true,
                });
            });
        },
        // inserted(el, binding, vndoe) {
        //     console.log("inserted");
        // },
    }
</script>
